import { AssertNeverError } from '@omnea-digital/toolbox'
import { TFunction } from 'i18next'
import { S3UploadFailure } from './uploadFilesToS3'

type FailureCategory = 'blocked' | 'http' | 'unknown'

const toFailureCategory = (failure: S3UploadFailure): FailureCategory => {
  switch (failure.kind) {
    case 'network':
    case 'timeout':
      return 'blocked'
    case 'http':
      return 'http'
    case 'unknown':
      return 'unknown'
    default:
      throw new AssertNeverError(failure)
  }
}

export const getUploadFailureMessage = (failures: S3UploadFailure[], t: TFunction<'documents', undefined>): string => {
  const [firstFailure] = failures
  if (!firstFailure) return t('upload-document-error')

  // Advice that fits one category is wrong for another, so a mixed batch only gets the count.
  const category = toFailureCategory(firstFailure)
  if (failures.some((failure) => toFailureCategory(failure) !== category)) {
    return t('upload-multiple-failed', { count: failures.length })
  }

  const count = failures.length
  const interpolation = count === 1 ? { count, fileName: firstFailure.fileName } : { count }

  switch (firstFailure.kind) {
    case 'network':
    case 'timeout':
      return t('upload-blocked-by-network', interpolation)
    case 'http':
      return t('upload-failed-server', interpolation)
    case 'unknown':
      return t('upload-document-error')
    default:
      throw new AssertNeverError(firstFailure)
  }
}
